module.exports = __webpack_public_path__ + "img/icon-butongguo.7b1dca44.png";